<!-- Inline: the dashed box of the upload step. Whatever happens to a drop happens in it. -->
<ngx-file-drop
  *ngIf="mode === 'inline'"
  class="zone zone--inline"
  [class.is-dragging]="dragging || sampleOver"
  [class.is-inviting]="!!invite && !carding && !choice"
  [class.is-uploading]="carding"
  [class.is-choosing]="!!choice && !carding"
  [class.is-refused]="refused && !carding && !choice"
  [class.is-disabled]="disabled && !carding"
  [multiple]="true"
  [disabled]="disabled || carding"
  dropZoneClassName="zone__target"
  contentClassName="zone__content"
  (onFileDrop)="onDropped($event)"
  (onFileOver)="onFileOver()"
  (onFileLeave)="onFileLeave()">
  <ng-template ngx-file-drop-content-tmp>
    <ng-container *ngIf="carding; else notCarding"><ng-container *ngTemplateOutlet="cardView"></ng-container></ng-container>
    <ng-template #notCarding>
      <ng-container *ngIf="choice; else idleView"><ng-container *ngTemplateOutlet="choiceView"></ng-container></ng-container>
    </ng-template>

    <ng-template #idleView>
      <!-- The designer's upload glyph (Figma 28511:21323), verbatim. -->
      <svg class="zone__glyph" width="30" height="32" viewBox="0 0 30.1559 32.1022" fill="none" aria-hidden="true"><path d="M1.40624 21.7865V27.8835C1.40624 29.4368 2.66543 30.696 4.21873 30.696H25.781C27.3343 30.696 28.5935 29.4368 28.5935 27.8835V21.7865" stroke="currentColor" stroke-width="2.81249" stroke-linecap="round" stroke-linejoin="round"/><path class="zone__glyph-arrow" fill-rule="evenodd" clip-rule="evenodd" d="M8.38004 6.61914C7.83099 7.16832 7.83092 8.05829 8.38004 8.60742C8.92918 9.15644 9.81918 9.15644 10.3683 8.60742L13.5927 5.383L13.5927 23.0752C13.5927 23.8518 14.2224 24.4814 14.999 24.4814C15.7756 24.4814 16.4052 23.8518 16.4052 23.0752L16.4052 5.38263L19.63 8.60742C20.1792 9.15657 21.0692 9.15659 21.6183 8.60742C22.1675 8.05825 22.1675 7.1683 21.6183 6.61914L14.9992 -3.72382e-08L8.38004 6.61914Z" fill="currentColor"/></svg>
      <strong class="zone__title">{{ invite ? 'Drop ' + invite + ' here' : 'Drop your model here' }}</strong>
      <p class="zone__hint">
        <ng-container *ngIf="hint; else formats">{{ hint }}</ng-container>
        <ng-template #formats>{{ (opensZip ? 'FBX, USDZ or ZIP' : 'FBX or USDZ') + ' · Prototype file limit: ' + limitLabel }}<ng-container *ngIf="helpLink"> · <button class="zone__help" type="button" (click)="helpRequested.emit()">How to include textures</button></ng-container></ng-template>
      </p>
      <div class="zone__actions">
        <button class="zone__button zone__button--outline" type="button" [disabled]="disabled" (click)="chooseFile()">Choose a file</button>
        <button class="zone__button" type="button" [disabled]="disabled" (click)="chooseFolder()">Choose a folder</button>
      </div>
      <p class="zone__collecting" *ngIf="collecting" role="status">Reading your files…</p>
    </ng-template>

    <!-- The card: an archive unpacking, then the upload (the library's upload card, with a bar under
         it). Files out of an archive get two legs, unpack and upload, so both steps show from the start. -->
    <ng-template #cardView>
      <div class="zone-upload" [class.is-done]="upload?.done">
        <div class="zone-upload__poster" [class.is-arriving]="arriving">
          <img *ngIf="upload?.poster; else formatTile" [src]="upload?.poster" alt="" width="88" height="88" draggable="false">
          <ng-template #formatTile><span class="zone-upload__format">{{ cardFormat }}</span></ng-template>
          <button *ngIf="!upload?.done; else doneMark" class="zone-upload__stop" type="button" [attr.aria-label]="upload ? 'Cancel upload' : 'Cancel unpacking'" (click)="cancelCard()">
            <svg class="zone-upload__ring" viewBox="0 0 44 44" aria-hidden="true"><circle class="zone-upload__track" cx="22" cy="22" r="20"/><circle class="zone-upload__arc" cx="22" cy="22" r="20"/></svg>
          </button>
          <ng-template #doneMark>
            <span class="zone-upload__done" aria-hidden="true"><svg width="18" height="18" viewBox="0 0 16 16" fill="none"><path d="M1 8.94753L5.2 13.1475L15 3.34753" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
          </ng-template>
        </div>
        <strong class="zone__title zone-upload__name" [title]="cardName">{{ cardName }}</strong>
        <p class="zone-upload__status" [title]="cardStatus">{{ cardStatus }}</p>
        <div class="zone-upload__legs" [class.is-phased]="phased" role="progressbar" [attr.aria-label]="(upload ? 'Uploading ' : 'Unpacking ') + cardName" aria-valuemin="0" aria-valuemax="100" [attr.aria-valuenow]="cardPercent">
          <div *ngIf="phased" class="zone-upload__bar" [class.is-busy]="opening"><div class="zone-upload__fill" [style.width.%]="unpackPercent"></div></div>
          <div class="zone-upload__bar"><div class="zone-upload__fill" [style.width.%]="upload ? percent : 0"></div></div>
        </div>
        <div *ngIf="phased" class="zone-upload__legend" aria-hidden="true"><span [class.is-on]="!upload">Unpack</span><span [class.is-on]="!!upload">Upload</span></div>
        <button *ngIf="!upload?.done" class="zone-upload__cancel" type="button" (click)="cancelCard()">{{ upload ? 'Cancel upload' : 'Cancel' }}</button>
        <p *ngIf="cardNote" class="zone-upload__note">{{ cardNote }}</p>
        <span class="sr-only" role="status">{{ upload?.done ? 'Uploaded. Starting your preview.' : cardStatus }}</span>
      </div>
    </ng-template>

    <!-- Several models: which one. A drop of other files replaces the question. -->
    <ng-template #choiceView>
      <div class="zone-choice" role="group" [attr.aria-labelledby]="choiceId + '-title'">
        <div class="zone-choice__head">
          <strong class="zone-choice__title" [id]="choiceId + '-title'">{{ choiceTitle }}</strong>
          <span class="zone-choice__lead">Pick one to preview. Only that model and its textures are uploaded.</span>
        </div>
        <label *ngIf="filtersChoice" class="zone-choice__filter">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>
          <input type="search" placeholder="Filter by name" aria-label="Filter the models by name" [value]="choiceFilter" (input)="onChoiceFilter($event)">
        </label>
        <div class="zone-choice__list" [class.is-long]="filtersChoice" role="radiogroup" [attr.aria-labelledby]="choiceId + '-title'">
          <label *ngFor="let option of shownChoices; trackBy: trackByPath" class="zone-choice__option" [class.is-on]="option.path === choice?.selected">
            <input type="radio" [name]="choiceId" [value]="option.path" [checked]="option.path === choice?.selected" (change)="choiceSelected.emit(option.path)">
            <span class="zone-choice__tile" aria-hidden="true">{{ option.format }}</span>
            <span class="zone-choice__name">{{ option.name }}<small *ngIf="option.folder">{{ option.folder }}</small></span>
            <span class="zone-choice__size">{{ option.size }}</span>
          </label>
          <p *ngIf="!shownChoices.length" class="zone-choice__none">No model matches “{{ choiceFilter }}”.</p>
        </div>
        <div class="zone-choice__foot">
          <button class="rf-button zone-choice__use" type="button" (click)="choiceConfirmed.emit()">Preview {{ chosenName }}</button>
          <button class="zone-choice__other" type="button" (click)="choiceDismissed.emit()">Choose other files</button>
          <small *ngIf="filtersChoice" class="zone-choice__count">{{ choice?.models?.length }} models · {{ choiceFolders }} folders</small>
        </div>
      </div>
    </ng-template>
  </ng-template>
</ngx-file-drop>

<!-- Overlay: whole-window target while a drag is in progress. -->
<div class="overlay" *ngIf="overlayVisible" [class.is-dragging]="dragging">
  <ngx-file-drop
    class="zone zone--overlay"
    [multiple]="true"
    dropZoneClassName="zone__target"
    contentClassName="zone__content"
    (onFileDrop)="onDropped($event)"
    (onFileOver)="onFileOver()"
    (onFileLeave)="onFileLeave()">
    <ng-template ngx-file-drop-content-tmp>
      <div class="overlay__card">
        <span class="zone__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M12 17V3m-5 5 5-5 5 5M4 16v5h16v-5"/></svg>
        </span>
        <strong class="zone__title">Drop your model to preview it</strong>
        <p class="zone__hint">{{ opensZip ? 'FBX, USDZ or ZIP · a file, a folder or an archive' : 'FBX or USDZ · a file or a folder' }}</p>
      </div>
    </ng-template>
  </ngx-file-drop>
</div>

<input #fileInput class="zone__input" type="file" [accept]="accept" tabindex="-1" aria-hidden="true" (change)="onInputChange($event)">
<input #folderInput class="zone__input" type="file" webkitdirectory multiple tabindex="-1" aria-hidden="true" (change)="onInputChange($event)">
